import { useAuth } from "../../../../context";
import { useMutation } from "react-query";
import { ScopeTwo } from "../../../../api/supplier-questionnaire/tabs";

export function useCreateScopeTwo(config) {
  const { callApi } = useAuth();
  return useMutation(({questionnaireId, data}) =>
    callApi(ScopeTwo.createScopeTwo, { questionnaireId, data }), config);
}

export function useUpdateScopeTwo(config) {
  const { callApi } = useAuth();
  return useMutation(({questionnaireId, id, data}) =>
    callApi(ScopeTwo.updateScopeTwo, { questionnaireId, id, data }), config);
}